// removed by extract-text-webpack-plugin
module.exports = {"thumbnails":"BSaJR","heading":"_2Sfet","stars":"_3YtVL","iconButton":"a1crJ","favButton":"_2DvUR a1crJ","flagButton":"_3Qd0q a1crJ","infoOverlay":"_1fNCV","controls":"_3yDyM","controlsShown":"_17oZO _3yDyM","controlsHidden":"oNG8W _3yDyM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/gallery/Gallery.css
// module id = 819
// module chunks = 0